import createModuleApi from "../../services/createModuleApi";
import api from "../../services/axiosConfig";

const crud = createModuleApi("/instances/governeye/fahras");

export const fetchUsers = crud.fetchAll;
export const createUser = crud.create;
export const deleteUser = crud.remove;

export const updateUser = async (userData) => {
  const res = await api.put(
    "/instances/governeye/fahras/update-user/",
    userData,
  );
  return res.data;
};

export const fetchRoles = async () => {
  const res = await api.get("/instances/governeye/fahras/list-roles");
  const rolesData = res.data.data;
  return Array.isArray(rolesData) ? rolesData : rolesData.data;
};
